<template>
  <v-container fill-height fluid>
    <v-row justify="center">
      <v-col cols="12">
        <base-material-card :title="title">
          <v-form @submit.prevent="handleSubmit">
            <v-container class="py-0">
              <v-row>
                <v-col v-if="selectSite" cols="6">
                  <v-autocomplete
                    autocomplete="off"
                    :disabled="isReadOnly"
                    :items="sites"
                    name="site"
                    label="Site"
                    v-model="resource.site"
                    item-text="name"
                    item-value="id"
                    hide-details
                  />
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    :disabled="isReadOnly"
                    v-model="resource.recipient"
                    name="recipient"
                    label="Recipient"
                  />
                </v-col>

                <v-col cols="4">
                  <v-autocomplete
                    autocomplete="off"
                    :disabled="isReadOnly"
                    :items="subscriptionTypes"
                    name="subscriptionType"
                    label="Report Type"
                    v-model="resource.subscriptionType"
                    hide-details
                  />
                </v-col>

                <v-col v-if="resource.subscriptionType == 'AllocationConsumption'" cols="3">
                  <v-autocomplete
                    autocomplete="off"
                    :disabled="isReadOnly"
                    :items="seperators"
                    name="separator"
                    label="Seperator"
                    v-model="resource.separator"
                    hide-details
                  />
                </v-col>

                <v-col cols="2">
                  <v-autocomplete
                    autocomplete="off"
                    :disabled="isReadOnly"
                    :items="times"
                    name="at"
                    label="Send At"
                    v-model="resource.sendInterval.at"
                  />
                </v-col>

                <v-col cols="2">
                  <v-autocomplete
                    autocomplete="off"
                    :disabled="isReadOnly"
                    :items="intervals"
                    name="interval"
                    label="Interval"
                    v-model="resource.sendInterval.type"
                    hide-details
                  />
                </v-col>

                <v-col v-if="resource.sendInterval.type == 2" cols="2">
                  <v-autocomplete
                    autocomplete="off"
                    :disabled="isReadOnly"
                    :items="daysOfTheWeek"
                    name="on"
                    label="Day of the Week"
                    v-model="resource.sendInterval.on"
                  />
                </v-col>

                <v-col v-if="resource.sendInterval.type == 3" cols="2">
                  <v-autocomplete
                    autocomplete="off"
                    :disabled="isReadOnly"
                    :items="daysOfTheMonth"
                    name="on"
                    label="Day of the Month"
                    v-model="resource.sendInterval.on"
                  />
                </v-col>
              </v-row>
              <v-row>
                <FormActions
                  :cancel="handleCancel"
                  :submit="handleSubmit"
                  :destroy="handleDestroy"
                  :canDestroy="canDestroy"
                  :canEdit="canEdit"
                  :canCreate="canCreate"
                  :isValid="isValid"
                  :submitting="submitting"
                />
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { flatten as _flatten, range as _range } from 'lodash';
import Formable from '@/mixins/formable';

export default {
  mixins: [Formable],
  props: {
    sites: {
      type: Array,
      default: () => [],
    },
    resource: {
      type: Object,
      default: () => {
        return { sendInterval: {}, deliveryMethod: 'email' };
      },
    },
  },
  computed: {
    selectSite() {
      return this.sites.length > 1;
    },
  },
  data() {
    return {
      resourceName: 'Subscription',
      subscriptionTypes: [
        { value: 'AllocationConsumption', text: 'Consumption Report' },
        { value: 'AllocationDispense', text: 'Dispense Report' },
      ],
      seperators: [
        { value: '', text: 'Nothing' },
        { value: 'user', text: 'User' },
        { value: 'app', text: 'Application' },
        { value: 'location', text: 'Location' },
      ],
      intervals: [
        { value: 1, text: 'Daily' },
        { value: 2, text: 'Weekly' },
        { value: 3, text: 'Monthly' },
      ],
      times: _flatten(
        ['am', 'pm'].map((ampm) => {
          return _flatten(
            [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((hour) => {
              return [`${hour}:00${ampm}`, `${hour}:30${ampm}`];
            }),
          );
        }),
      ),
      daysOfTheWeek: [
        { value: 0, text: 'Sunday' },
        { value: 1, text: 'Monday' },
        { value: 2, text: 'Tuesday' },
        { value: 3, text: 'Wednesday' },
        { value: 4, text: 'Thursday' },
        { value: 5, text: 'Friday' },
        { value: 6, text: 'Saturday' },
      ],
      daysOfTheMonth: _range(1, 29),
    };
  },
};
</script>
